import { apiGet } from './client';

export interface TakeoutMenu {
  id: string;
  storeId: string;
  name: string;
  description?: string | null;
  category?: string | null;
  price: number;
  isActive: boolean;
  displayOrder: number;
}

export async function listTakeoutMenus(storeId: string): Promise<TakeoutMenu[]> {
  try {
    return await apiGet<TakeoutMenu[]>(
      `/api/stores/${encodeURIComponent(storeId)}/takeout-menus?includeInactive=false`,
    );
  } catch {
    return [];
  }
}
